angular.module('igsSolarOps').directive('format', ['$filter', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
            if (!ctrl) return;


            ctrl.$formatters.unshift(function (a) {
                return $filter(attrs.format)(ctrl.$modelValue);
            });


            ctrl.$parsers.unshift(function (viewValue) {
                var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
                if (plainNumber.indexOf('.') > 0 && plainNumber.length > plainNumber.indexOf('.') + 3) {
                    plainNumber = plainNumber.substring(0, plainNumber.indexOf('.') + 3);
                }
                if (!viewValue.endsWith('.')) {
                    elem.val($filter(attrs.format)(plainNumber));
                }
                return plainNumber;
            });
        }
    };
}]);